import type { HelpFile } from '../../types/help'
import { PropertyPanelTestIds } from '../../../testids/PropertyPanelTestIds'

export const propertyPanelHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [PropertyPanelTestIds.cardTitleProperties]:
      'Properties of the currently selected element in the form layout designer.',
    [PropertyPanelTestIds.propertyPanelCloseBtn]: null,
  },
}
